import { render, staticRenderFns } from "./Beginpage.vue?vue&type=template&id=37b9e824&scoped=true"
import script from "./Beginpage.vue?vue&type=script&lang=js"
export * from "./Beginpage.vue?vue&type=script&lang=js"
import style0 from "./Beginpage.vue?vue&type=style&index=0&id=37b9e824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9e824",
  null
  
)

export default component.exports